import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "question-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dot_que_half_screen_tile = _resolveComponent("dot-que-half-screen-tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionList, (item, index) => {
      return (_openBlock(), _createBlock(_component_dot_que_half_screen_tile, {
        key: index,
        curTime: $props.curTime,
        displayRange: $props.displayRange,
        questionData: item.question_info,
        questionIndex: index,
        onHandleAfterRender: $setup.handleAfterRender,
        onHandleChooseOption: $setup.handleChooseOption
      }, null, 8, ["curTime", "displayRange", "questionData", "questionIndex", "onHandleAfterRender", "onHandleChooseOption"]))
    }), 128))
  ]))
}